import React from "react";
import { Link } from "react-router-dom";
import "./neet-preparation.css";

const highlights = [
  {
    icon: "school",
    title: "Target Groups",
    desc: "Dedicated batches for Class 11 (Two-year), Class 12 (One-year), and Droppers with focused medical entrance preparation.",
  },
  {
    icon: "calendar_month",
    title: "Batch Modes",
    desc: "Offline Classroom, Live Online, and Hybrid options with structured NCERT-first teaching and practice.",
  },
  {
    icon: "track_changes",
    title: "Key Focus Areas",
    desc: "NCERT mastery, high-yield question practice, exam strategy, time management, and performance analysis.",
  },
];

const syllabus = [
  { icon: "science", title: "Physics", body: "NEET-focused concepts, formula mastery, error reduction techniques, and frequent practice with PYQs." },
  { icon: "experiment", title: "Chemistry", body: "NCERT line-by-line coverage, concept + factual accuracy, and smart revision modules." },
  { icon: "biotech", title: "Biology", body: "NCERT-based Biology with diagrams, keywords, and high-frequency NEET patterns." },
];

const advantages = [
  { icon: "menu_book", title: "NCERT First Approach", desc: "Strong NCERT-based teaching with exam-level question practice." },
  { icon: "assignment", title: "Regular Mock Tests", desc: "Weekly tests with analysis + full-syllabus mocks near exam time." },
  { icon: "insights", title: "Performance Tracking", desc: "Detailed reports highlighting weak areas and improvement roadmap." },
  { icon: "groups", title: "Small Batch Size", desc: "Limited students per batch ensuring personal attention." },
  { icon: "workspace_premium", title: "Mentorship Program", desc: "One-on-one mentoring to maintain consistency and reduce stress." },
  { icon: "local_library", title: "Practice Support", desc: "Dedicated doubt support and guided revision planning." },
];

const NEETPreparation: React.FC = () => {
  const guidanceFormUrl = "https://forms.gle/xdExtHf2Yss4ZaHq9";
  return (
    <div className="jp-page jp-page--neet">
      <div className="jp-container">
        {/* Tabs */}
        <div className="jp-tabs">
          <Link className="jp-tab" to="/courses/jee">
            JEE Preparation
          </Link>
          <Link className="jp-tab is-active" to="/courses/neet">
            NEET Preparation
          </Link>
        </div>

        {/* Hero */}
        <section className="jp-hero jp-hero--neet">
          <div
            className="jp-hero__image"
            style={{ backgroundImage: "url('/mode/neet_course.png')" }}
          />
          <div className="jp-hero__content">
            <span className="jp-badge">
              <span className="material-symbols-outlined">health_and_safety</span>
              MEDICAL WING
            </span>

            <h1 className="jp-hero__title">
              NEET UG
              <br />
              Coaching
            </h1>

            <p className="jp-hero__subtitle">
              Complete NEET preparation with strong NCERT foundation, high-yield practice, and personalized mentorship to boost score and rank.
            </p>

            <div className="jp-hero__actions">
              <a className="jp-btn jp-btn--primary" href={guidanceFormUrl} target="_blank" rel="noopener noreferrer">
                Register for Career Guidance
              </a>
              <Link className="jp-btn jp-btn--secondary" to="/our-students">
                View Success Stories
              </Link>
            </div>
          </div>
        </section>

        {/* Highlights */}
        <section className="jp-section">
          <h2 className="jp-section__title">Course Highlights</h2>

          <div className="jp-grid jp-grid--3">
            {highlights.map((h) => (
              <article className="jp-card" key={h.title}>
                <div className="jp-card__icon">
                  <span className="material-symbols-outlined">{h.icon}</span>
                </div>
                <h3 className="jp-card__title">{h.title}</h3>
                <p className="jp-card__text">{h.desc}</p>
              </article>
            ))}
          </div>
        </section>

        {/* Curriculum */}
        <section className="jp-section jp-section--spaced">
          <div className="jp-section__head">
            <div>
              <h2 className="jp-section__title">Curriculum &amp; Syllabus</h2>
              <p className="jp-section__subtitle">Comprehensive coverage of NEET topics</p>
            </div>

            <button className="jp-link">Download Full Syllabus PDF</button>
          </div>

          <div className="jp-accordion">
            {syllabus.map((s) => (
              <details className="jp-accordion__item" key={s.title}>
                <summary className="jp-accordion__summary">
                  <span className="jp-accordion__left">
                    <span className="material-symbols-outlined">{s.icon}</span>
                    {s.title}
                  </span>
                  <span className="material-symbols-outlined jp-accordion__chev">expand_more</span>
                </summary>
                <div className="jp-accordion__body">
                  <p>{s.body}</p>
                </div>
              </details>
            ))}
          </div>

          <div className="jp-note">
            <span className="material-symbols-outlined">info</span>
            <div>
              <strong>Note:</strong> Daily doubt solving + revision schedule + test analysis is included in all batches.
            </div>
          </div>
        </section>

        {/* Advantage */}
        <section className="jp-section jp-section--spaced">
          <h2 className="jp-section__title">The S-CUBUS Advantage</h2>

          <div className="jp-grid jp-grid--3">
            {advantages.map((a) => (
              <article className="jp-adv" key={a.title}>
                <div className="jp-adv__icon">
                  <span className="material-symbols-outlined">{a.icon}</span>
                </div>
                <div>
                  <h3 className="jp-adv__title">{a.title}</h3>
                  <p className="jp-adv__text">{a.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="jp-cta">
          <div className="jp-cta__content">
            <h2 className="jp-cta__title">Ready to ace your exams?</h2>
            <p className="jp-cta__text">Join the league of toppers today. Limited seats available for upcoming batches.</p>
          </div>

          <div className="jp-cta__actions">
            <a className="jp-btn jp-btn--primary" href={guidanceFormUrl} target="_blank" rel="noopener noreferrer">
              Register for Free Guidance Demo
            </a>
            <button className="jp-btn jp-btn--ghost">
              <span className="material-symbols-outlined">download</span>
              Brochure
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NEETPreparation;
